export const iconFontAwesomeDesignObjectGroup = (
	<i className="fa-solid fa-object-group"></i>
);
